import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39938698"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-oem__tabs" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "user-oem__tab-line" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "user-oem__title flex-bwn"
}
const _hoisted_6 = { class: "user-oem__times" }
const _hoisted_7 = { class: "user-oem__times-num" }
const _hoisted_8 = {
  key: 0,
  class: "user-oem__oem"
}
const _hoisted_9 = { class: "user-oem__list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "user-oem__item-name" }
const _hoisted_13 = {
  key: 1,
  class: "user-oem__small-lot"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "user-oem__metric-label" }
const _hoisted_16 = { class: "user-oem__metric-value" }

import { computed, onMounted, reactive, ref } from 'vue'
import { t } from '@/plugins/i18n'
import { request } from '@/config/request/interceptors'
import { useLevel, useRtfix } from '@/store'
import { ElMessageBox } from 'element-plus'
import { ArrowRight } from '@element-plus/icons-vue'
import router from '@/router'

/** OEM 工作台 tab 枚举。 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const TAB_TYPE = {
  OEM: 'OEM',
  SMALL_LOT: 'SMALL_LOT'
} as const

/** 小ロット生産商品列表页面路径。 */
const SMALL_LOT_GOODS_ROUTE = '/oem/smallOrderQuickResponse/productionGoods'

/** OEM 工作台 tab 列表。 */
const tabs = [
  { label: t('小ロット生産'), value: TAB_TYPE.SMALL_LOT },
  { label: 'OEM', value: TAB_TYPE.OEM }
]

/** OEM 功能入口列表。 */
const oemTypeList = reactive([
  {
    name: t('新增寻源任务'),
    icon: 'https://static-s.theckb.com/BusinessMarket/member/client_oem_icon1.png',
    route: '/oem/order/addFindSource'
  },
  {
    name: t('寻源单列表'),
    icon: 'https://static-s.theckb.com/BusinessMarket/member/client_oem_icon2.png',
    route: '/oem/order/oemSourceList'
  },
  {
    name: t('OEM商品'),
    icon: 'https://static-s.theckb.com/BusinessMarket/member/client_oem_icon3.png',
    route: '/oem/goods/list'
  }
])

/** 小ロット生産工作台指标配置。 */
const smallLotMetrics = reactive([
  {
    key: 'pendingQuotationCount',
    label: t('見積確認待ち'),
    value: 0,
    route: `${SMALL_LOT_GOODS_ROUTE}?search=price`
  },
  {
    key: 'pendingFabricConfirmCount',
    label: t('生地確認待ち'),
    value: 0,
    route: `${SMALL_LOT_GOODS_ROUTE}?search=fabric`
  },
  {
    key: 'pendingSampleConfirmCount',
    label: t('サンプル確認待ち'),
    value: 0,
    route: `${SMALL_LOT_GOODS_ROUTE}?search=sample`
  }
])

/** 当前激活的 OEM 工作台 tab。 */
const activeTab = ref<(typeof TAB_TYPE)[keyof typeof TAB_TYPE]>(TAB_TYPE.OEM)
/** 当前用户是否命中小ロット生産白名单。 */
const hasSmallLotPermission = ref(false)
/** 免费寻源剩余次数。 */
const freeCount = ref(0)
/** 小ロット生産统计加载状态。 */
const smallLotLoading = ref(false)
/** 是否已经拉取过小ロット生産指标。 */
const smallLotLoaded = ref(false)

const level = useLevel()
const warningImg = require('@/assets/image/icon/member/icon_hint@2x.png')

/** 根据当前 tab 生成卡片样式类名。 */
const activeTabClass = computed(() => {
  return activeTab.value === TAB_TYPE.SMALL_LOT ? 'is-small-lot' : 'is-oem'
})

/** 当前页面实际展示的 OEM tab 列表。 */
const visibleTabs = computed(() => {
  return hasSmallLotPermission.value ? tabs : tabs.filter(item => item.value === TAB_TYPE.OEM)
})

/** 打开会员限制提示弹窗。 */
const confirmMember = () => {
  ElMessageBox.confirm(
    `<img src='${warningImg}' style='position:absolute;top:-38px;height:20px;width:20px'/><p style='white-space:pre-wrap'>
      ${t('标准舱客户可以提供OEM资材服务。商务舱及以上客户可以提供服装，杂货OEM服务')}
    <p>`,
    t('注意3'),
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: t('会员登录'),
      cancelButtonText: t('关闭'),
      distinguishCancelAndClose: true,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      customClass: 'sidebarMemberConfirm'
    }
  )
    .then(() => {
      /** 会员升级页面路由。 */
      const routerUrl: any = router.resolve(useRtfix('VipLevel'))
      window.open(routerUrl.href, '_black')
    })
}

/** 判断当前会员等级是否可使用 OEM 相关能力。 */
const checkMemberLevel = () => {
  if (level <= 1) {
    confirmMember()
    return false
  }
  return true
}

/** OEM 功能模块点击跳转。 */
const jump = (item: typeof oemTypeList[number]) => {
  if (!checkMemberLevel()) return
  location.href = item.route
}

/** 小ロット生産指标点击跳转。 */
const jumpSmallLot = (item: typeof smallLotMetrics[number]) => {
  if (!checkMemberLevel()) return
  location.href = item.route
}

/** 跳转小ロット生産全部商品列表，不携带筛选参数。 */
const jumpSmallLotGoodsList = () => {
  if (!checkMemberLevel()) return
  location.href = SMALL_LOT_GOODS_ROUTE
}

/** 切换 OEM 工作台 tab。 */
const handleTabChange = async (tab: (typeof TAB_TYPE)[keyof typeof TAB_TYPE]) => {
  activeTab.value = tab
  if (tab === TAB_TYPE.SMALL_LOT) {
    await loadSmallLotCount()
  }
}

/** 查询当前用户是否命中小ロット生産白名单。 */
const loadSmallLotPermission = async () => {
  /** 小ロット生産权限接口响应。 */
  const res = await request.order.quickResponse.permission()
  // order/searchSourceOrder/show/list
  const res1 = await request.order.searchSourceOrder.showList({ oemBusinessType: 2, pageNum: 1, pageSize: 30 })
  hasSmallLotPermission.value = Boolean(res.data?.enabled || res1.data?.total)
  activeTab.value = hasSmallLotPermission.value ? TAB_TYPE.SMALL_LOT : TAB_TYPE.OEM
  if (hasSmallLotPermission.value) {
    await loadSmallLotCount()
  }
}

/** 拉取小ロット生産工作台计数。 */
const loadSmallLotCount = async () => {
  if (smallLotLoading.value || smallLotLoaded.value) return
  smallLotLoading.value = true
  try {
    /** 小ロット生産工作台统计接口响应。 */
    const res = await request.order.quickResponse.workbenchCount()
    /** 小ロット生産工作台统计数据。 */
    const countData = res.data || {}
    smallLotMetrics[0].value = countData.waitQuoteConfirmCount ?? 0
    smallLotMetrics[1].value = countData.waitFabricConfirmCount ?? 0
    smallLotMetrics[2].value = countData.waitSampleConfirmCount ?? 0
    smallLotLoaded.value = true
  } finally {
    smallLotLoading.value = false
  }
}

onMounted(async () => {
  /** 免费寻源次数接口响应。 */
  const { data: { currentAvailableQuantity } = {} } = await request.customer.free.countSelectFreeCountByType({ type: 2 })
  freeCount.value = currentAvailableQuantity ?? 0
  await loadSmallLotPermission()
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['user-oem', _unref(activeTabClass)])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleTabs), (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.value,
            type: "button",
            class: _normalizeClass(['user-oem__tab', { 'is-active': activeTab.value === item.value }]),
            onClick: ($event: any) => (handleTabChange(item.value))
          }, [
            _createElementVNode("span", null, _toDisplayString(item.label), 1),
            _hoisted_4
          ], 10, _hoisted_3))
        }), 128))
      ]),
      (activeTab.value == _unref(TAB_TYPE).OEM)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(t)('免费寻源')) + " ", 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(freeCount.value), 1),
              _createTextVNode(" " + _toDisplayString(_unref(t)('次')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === _unref(TAB_TYPE).SMALL_LOT)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "user-oem__all",
            onClick: jumpSmallLotGoodsList
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('生产依赖商品一覧')), 1),
            _createVNode(_component_el_icon, { class: "user-oem__all-icon" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowRight))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (activeTab.value === _unref(TAB_TYPE).OEM)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(oemTypeList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.route,
                class: "user-oem__item",
                onClick: ($event: any) => (jump(item))
              }, [
                _createElementVNode("img", {
                  class: "user-oem__item-icon",
                  src: item.icon
                }, null, 8, _hoisted_11),
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1)
              ], 8, _hoisted_10))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(smallLotMetrics), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.key,
              class: "user-oem__metric",
              onClick: ($event: any) => (jumpSmallLot(item))
            }, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(item.label), 1),
              _createElementVNode("div", _hoisted_16, _toDisplayString(item.value), 1)
            ], 8, _hoisted_14))
          }), 128))
        ]))
  ], 2)), [
    [_directive_loading, smallLotLoading.value]
  ])
}
}

})